import { Injectable } from '@angular/core';
import Web3 from "web3";

// import { Contracts_Rinkeby } from 'src/environments/environment';
// import { Contracts_Rinkeby } from "../BlockChainInfo";
import { Polygon,rinkebyJSON } from '../BlockChainInfo';


@Injectable({
  providedIn: 'root'
})
export class ContractService {
  network_name: any;

  constructor() { }

  public getNetwork() {

    return this.network_name

  }

  public setNetwork(name) {
    this.network_name = name
  }

  public getContract(contractType) {
    var contract_nw;
    var abi, networkAddress;
    const SINGLE_NFT721_JSON = require('src/app/Contracts/Rinkeby/NFT.json');
    const MULTIPLE_NFT1155_JSON = require('src/app/Contracts/Rinkeby/MultNFT.json');
    const MARKET_PLACE_JSON = require('src/app/Contracts/Rinkeby/MarketPlace.json');
    const ERC_20_JSON = require('src/app/Contracts/Rinkeby/ERC20.json')

    if (this.network_name == 'Ethereum Rinkeby') {
      contract_nw = localStorage.getItem('networkId') == 'Polygon' ? Polygon : rinkebyJSON;
    }
    console.log("CONtracts NW is ", contract_nw)
    // const SINGLE_NFT721_JSON = require(contract_nw.SINGLE_NFT721_JSON);

    if (contractType === 'ERC721') {
      abi = SINGLE_NFT721_JSON;
      networkAddress = contract_nw.SINGLE_NFT721_ADDRESS;
    } else if (contractType == 'ERC1155') {
      abi = MULTIPLE_NFT1155_JSON;
      networkAddress = contract_nw.MULTIPLE_NFT1155_ADDRESS;
    } else if (contractType === 'MarketPlace') {
      abi = MARKET_PLACE_JSON;
      networkAddress = contract_nw.MARKET_PLACE_ADDRESS;
    } else if (contractType === 'ERC20') {
      abi = ERC_20_JSON;
      networkAddress = contract_nw.ERC_20_ADDRESS;
    }
    const web3 = new Web3()
    console.log("ABI is", abi);
    console.log("address is", networkAddress)
    const smartContract = new web3.eth.Contract(abi, networkAddress);
    return smartContract;

  }
}